import { axiosInst } from './index';
// import store from './index';

//기본 주소 조회
function getAddress(userId) {
	return axiosInst.get('/v1/addr/getaddr', { params: { userId } });
}

//전체 주소 조회
function getAllAddress(userId) {
	return axiosInst.get('/v1/addr/getaddrlist', { params: { userId } });
}

//주소 추가
function addAddress(addData) {
	return axiosInst.post('/v1/addr/add', addData);
}

//주소 업데이트
function updateAddress(addData) {
	return axiosInst.post('v1/addr/modified', addData);
}

//주소 삭제
function removeAddress(addData) {
	return axiosInst.post('v1/addr/deladdr', addData);
}

export { getAddress, getAllAddress, addAddress, updateAddress, removeAddress };
